import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { Button, Header, Icon, Segment } from "semantic-ui-react";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import "./Operaciones_style.css";
import {
  CCTMovimientoReportes,
  CCTMovimientoReportesFormValues,
} from "../../app/models/CCTMovimientoReporte";
import ReactDOM from "react-dom";
import CCTMovimientoUpdate from "../Modals/CCTMovimientoUpdate";

export default observer(function OperacionesTabla() {
  const { CCTMovimientoReporteStore, modalStore } = useStore();
  const { CCTMovimientoByCodigo, updateCCTMovimiento } =
    CCTMovimientoReporteStore;

  return (
    <div id="contenedor_busqueda_movimiento">
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <b>Fecha</b>
              </TableCell>
              <TableCell align="center">
                <b>DPI</b>
              </TableCell>
              <TableCell align="center">
                <b>Nombre</b>
              </TableCell>
              <TableCell align="center">
                <b>Cuenta</b>
              </TableCell>
              <TableCell align="center">
                <b>Descripcion</b>
              </TableCell>
              <TableCell align="center">
                <b>Numero Transaccion</b>
              </TableCell>
              <TableCell align="center">
                <b>Estatus</b>
              </TableCell>
              <TableCell align="center">
                <b>Usuaio registro</b>
              </TableCell>
              <TableCell align="center">
                <b>fecha registro</b>
              </TableCell>
              <TableCell align="center">
                <b>Usuario anulo</b>
              </TableCell>
              <TableCell align="center">
                <b>Fecha anulacion</b>
              </TableCell>
              <TableCell align="center">
                <b>Cargo</b>
              </TableCell>
              <TableCell align="center">
                <b>Abono</b>
              </TableCell>
              <TableCell align="center">
                <b>63A</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {CCTMovimientoByCodigo.map((activities) => {
              var CCTMovimiento: CCTMovimientoReportesFormValues;
              return (
                <>
                  {activities.cuentas.map((cuenta) => {
                    return (
                      <>
                        {cuenta.transacciones.map((transaccion) => {
                          return (
                            <>
                              {transaccion.movimientos.map((movimiento) => {
                                const nf1 = new Intl.NumberFormat("es-MX");
                                var valor_formato = nf1.format(
                                  movimiento.valor
                                );
                                if (movimiento.valor % 1 == 0) {
                                  valor_formato = valor_formato + ".00";
                                }
                                if (movimiento.codigoOperacion == "-1") {
                                  if (movimiento.estatusMovimiento == "AC") {
                                    return (
                                      <TableRow>
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          align="center"
                                        >
                                          {movimiento.fecha}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.dpi}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.nombre}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.cuenta}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.numeroTransaccion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.estatusMovimiento}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.usuarioRegistro}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.fechaRegistro}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.usuarioAnulo}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.fechaAnulado}
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center">
                                          {valor_formato}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.numeroDeDocumentoContable}
                                        </TableCell>
                                        <Button
                                          aria-label="delete"
                                          color="red"
                                          onClick={() => {
                                            let movimientoInfo: CCTMovimientoReportes =
                                              {
                                                fechaInicial:
                                                  activities.fechaInicial,
                                                fechaFinal:
                                                  activities.fechaFinal,
                                                cuentas: [
                                                  {
                                                    tipo: cuenta.tipo,
                                                    total: cuenta.total,
                                                    transacciones: [
                                                      {
                                                        tipo: transaccion.tipo,
                                                        total:
                                                          transaccion.total,
                                                        movimientos: [
                                                          {
                                                            id: movimiento.id,
                                                            fecha:
                                                              movimiento.fecha,
                                                            dpi: movimiento.dpi,
                                                            nombre:
                                                              movimiento.nombre,
                                                            codigoOperacion:
                                                              movimiento.codigoOperacion,
                                                            descripcion:
                                                              movimiento.descripcion,
                                                            valor:
                                                              movimiento.valor,
                                                            cuenta:
                                                              movimiento.cuenta,
                                                            codigoTipoTransaccion:
                                                              movimiento.codigoTipoTransaccion,
                                                            numeroTransaccion:
                                                              movimiento.numeroTransaccion,
                                                            estatusMovimiento:
                                                              "AN",
                                                            usuarioRegistro:
                                                              movimiento.usuarioRegistro,
                                                            fechaRegistro:
                                                              movimiento.fechaRegistro,
                                                            usuarioAnulo:
                                                              movimiento.usuarioAnulo,
                                                            fechaAnulado:
                                                              movimiento.fechaAnulado,
                                                            numeroDeDocumentoContable:
                                                              movimiento.numeroDeDocumentoContable,
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                ],
                                              };
                                            modalStore.openModal(
                                              <CCTMovimientoUpdate
                                                move={CCTMovimiento}
                                                id={movimiento.id}
                                                tipo="AN"
                                                data={movimientoInfo}
                                              />,
                                              'mini'
                                            );
                                          }}
                                        >
                                          Anular
                                        </Button>
                                      </TableRow>
                                    );
                                  } else {
                                    return (
                                      <TableRow>
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          align="center"
                                        >
                                          {movimiento.fecha}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.dpi}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.nombre}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.cuenta}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.numeroTransaccion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.estatusMovimiento}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.usuarioRegistro}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.fechaRegistro}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.usuarioAnulo}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.fechaAnulado}
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center">
                                          {valor_formato}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.numeroDeDocumentoContable}
                                        </TableCell>
                                        <Button
                                          aria-label="delete"
                                          color="green"
                                          onClick={() => {
                                            let movimientoInfo: CCTMovimientoReportes =
                                              {
                                                fechaInicial:
                                                  activities.fechaInicial,
                                                fechaFinal:
                                                  activities.fechaFinal,
                                                cuentas: [
                                                  {
                                                    tipo: cuenta.tipo,
                                                    total: cuenta.total,
                                                    transacciones: [
                                                      {
                                                        tipo: transaccion.tipo,
                                                        total:
                                                          transaccion.total,
                                                        movimientos: [
                                                          {
                                                            id: movimiento.id,
                                                            fecha:
                                                              movimiento.fecha,
                                                            dpi: movimiento.dpi,
                                                            nombre:
                                                              movimiento.nombre,
                                                            codigoOperacion:
                                                              movimiento.codigoOperacion,
                                                            descripcion:
                                                              movimiento.descripcion,
                                                            valor:
                                                              movimiento.valor,
                                                            cuenta:
                                                              movimiento.cuenta,
                                                            codigoTipoTransaccion:
                                                              movimiento.codigoTipoTransaccion,
                                                            numeroTransaccion:
                                                              movimiento.numeroTransaccion,
                                                            estatusMovimiento:
                                                              "AC",
                                                            usuarioRegistro:
                                                              movimiento.usuarioRegistro,
                                                            fechaRegistro:
                                                              movimiento.fechaRegistro,
                                                            usuarioAnulo:
                                                              movimiento.usuarioAnulo,
                                                            fechaAnulado:
                                                              movimiento.fechaAnulado,
                                                            numeroDeDocumentoContable:
                                                              movimiento.numeroDeDocumentoContable,
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                ],
                                              };
                                            modalStore.openModal(
                                              <CCTMovimientoUpdate
                                                move={CCTMovimiento}
                                                id={movimiento.id}
                                                tipo="AC"
                                                data={movimientoInfo}
                                              />,
                                              'mini'
                                            );
                                          }}
                                        >
                                          Activar
                                        </Button>
                                      </TableRow>
                                    );
                                  }
                                } else {
                                  if (movimiento.estatusMovimiento == "AC") {
                                    return (
                                      <TableRow>
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          align="center"
                                        >
                                          {movimiento.fecha}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.dpi}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.nombre}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.cuenta}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.numeroTransaccion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.estatusMovimiento}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.usuarioRegistro}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.fechaRegistro}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.usuarioAnulo}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.fechaAnulado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {valor_formato}
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center">
                                          {movimiento.numeroDeDocumentoContable}
                                        </TableCell>
                                        <Button
                                          aria-label="delete"
                                          color="red"
                                          onClick={() => {
                                            let movimientoInfo: CCTMovimientoReportes =
                                              {
                                                fechaInicial:
                                                  activities.fechaInicial,
                                                fechaFinal:
                                                  activities.fechaFinal,
                                                cuentas: [
                                                  {
                                                    tipo: cuenta.tipo,
                                                    total: cuenta.total,
                                                    transacciones: [
                                                      {
                                                        tipo: transaccion.tipo,
                                                        total:
                                                          transaccion.total,
                                                        movimientos: [
                                                          {
                                                            id: movimiento.id,
                                                            fecha:
                                                              movimiento.fecha,
                                                            dpi: movimiento.dpi,
                                                            nombre:
                                                              movimiento.nombre,
                                                            codigoOperacion:
                                                              movimiento.codigoOperacion,
                                                            descripcion:
                                                              movimiento.descripcion,
                                                            valor:
                                                              movimiento.valor,
                                                            cuenta:
                                                              movimiento.cuenta,
                                                            codigoTipoTransaccion:
                                                              movimiento.codigoTipoTransaccion,
                                                            numeroTransaccion:
                                                              movimiento.numeroTransaccion,
                                                            estatusMovimiento:
                                                              "AN",
                                                            usuarioRegistro:
                                                              movimiento.usuarioRegistro,
                                                            fechaRegistro:
                                                              movimiento.fechaRegistro,
                                                            usuarioAnulo:
                                                              movimiento.usuarioAnulo,
                                                            fechaAnulado:
                                                              movimiento.fechaAnulado,
                                                            numeroDeDocumentoContable:
                                                              movimiento.numeroDeDocumentoContable,
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                ],
                                              };
                                            modalStore.openModal(
                                              <CCTMovimientoUpdate
                                                move={CCTMovimiento}
                                                id={movimiento.id}
                                                tipo="AN"
                                                data={movimientoInfo}
                                              />,
                                              'mini'
                                            );
                                          }}
                                        >
                                          Anular
                                        </Button>
                                      </TableRow>
                                    );
                                  } else {
                                    return (
                                      <TableRow>
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          align="center"
                                        >
                                          {movimiento.fecha}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.dpi}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.nombre}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.cuenta}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.numeroTransaccion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.estatusMovimiento}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.usuarioRegistro}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.fechaRegistro}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.usuarioAnulo}
                                        </TableCell>
                                        <TableCell align="center">
                                          {movimiento.fechaAnulado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {valor_formato}
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center">
                                          {movimiento.numeroDeDocumentoContable}
                                        </TableCell>
                                        <Button
                                          aria-label="delete"
                                          color="green"
                                          onClick={() => {
                                            let movimientoInfo: CCTMovimientoReportes =
                                              {
                                                fechaInicial:
                                                  activities.fechaInicial,
                                                fechaFinal:
                                                  activities.fechaFinal,
                                                cuentas: [
                                                  {
                                                    tipo: cuenta.tipo,
                                                    total: cuenta.total,
                                                    transacciones: [
                                                      {
                                                        tipo: transaccion.tipo,
                                                        total:
                                                          transaccion.total,
                                                        movimientos: [
                                                          {
                                                            id: movimiento.id,
                                                            fecha:
                                                              movimiento.fecha,
                                                            dpi: movimiento.dpi,
                                                            nombre:
                                                              movimiento.nombre,
                                                            codigoOperacion:
                                                              movimiento.codigoOperacion,
                                                            descripcion:
                                                              movimiento.descripcion,
                                                            valor:
                                                              movimiento.valor,
                                                            cuenta:
                                                              movimiento.cuenta,
                                                            codigoTipoTransaccion:
                                                              movimiento.codigoTipoTransaccion,
                                                            numeroTransaccion:
                                                              movimiento.numeroTransaccion,
                                                            estatusMovimiento:
                                                              "AC",
                                                            usuarioRegistro:
                                                              movimiento.usuarioRegistro,
                                                            fechaRegistro:
                                                              movimiento.fechaRegistro,
                                                            usuarioAnulo:
                                                              movimiento.usuarioAnulo,
                                                            fechaAnulado:
                                                              movimiento.fechaAnulado,
                                                            numeroDeDocumentoContable:
                                                              movimiento.numeroDeDocumentoContable,
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                ],
                                              };
                                            modalStore.openModal(
                                              <CCTMovimientoUpdate
                                                move={CCTMovimiento}
                                                id={movimiento.id}
                                                tipo="AC"
                                                data={movimientoInfo}
                                              />,
                                              'mini'
                                            );
                                          }}
                                        >
                                          Activar
                                        </Button>
                                      </TableRow>
                                    );
                                  }
                                }
                              })}
                            </>
                          );
                        })}
                      </>
                    );
                  })}
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
});
